import Service from "../../Services";

const SubMenu = {
  namespaced: true,
  state: {
    form: {
      sub_menu_id: "",
      menu_id: "",
      title_th: "",
      title_en: "",
      description_th: "",
      description_en: "",
      service_id: "",
      slug_url: "",
      is_publish: true
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        sub_menu_id: "",
        menu_id: "",
        title_th: "",
        title_en: "",
        description_th: "",
        description_en: "",
        service_id: "",
        slug_url: "",
        is_publish: true
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getSubMenu({ commit }, page) {
      return Service.SubMenuAPI.getSubMenu(page);
    },
    // eslint-disable-next-line no-unused-vars
    showSubMenu({ commit }, id) {
      return Service.SubMenuAPI.showSubMenu(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveSubMenu({ commit }, { id, data }) {
      if (id) {
        return Service.SubMenuAPI.updateSubMenu(id, data);
      } else {
        return Service.SubMenuAPI.createSubMenu(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteSubMenu({ commit }, id) {
      return Service.SubMenuAPI.deleteSubMenu(id);
    },
    // eslint-disable-next-line no-unused-vars
    getSubMenuFromMenuId({ commit }, id) {
      return Service.SubMenuAPI.getSubMenuFromMenuId(id);
    },
    setFormSubMenu({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default SubMenu;
